import { Tarjeta } from "../components/Tarjeta";
import { useAuthSuperadmin } from "./SuperadminAuthContext";

// Placeholder de BLOQUE 2: prueba de punta a punta que el realm de
// autenticación de plataforma funciona. El dashboard real (estudios,
// métricas, incidencias) se construye en BLOQUE 7.
export function SuperadminDashboardPage() {
  const { superadmin } = useAuthSuperadmin();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-white">
          Panel de plataforma
        </h1>
        <p className="mt-1 text-sm text-slate-400">
          Sesión de plataforma activa — el dashboard completo (estudios,
          métricas, incidencias) llega en un bloque posterior.
        </p>
      </div>
      <Tarjeta className="p-6">
        <p className="text-sm text-slate-600">
          Conectado como <strong>{superadmin?.nombre_completo}</strong> (
          {superadmin?.email})
        </p>
      </Tarjeta>
    </div>
  );
}
